<template>
    <div class="cmp-tab">
        <div class="cmp-filterbar">
            <div class="cmp-frow">
                <a-input
                    class="cmp-ff cmp-ff-search"
                    placeholder="Descrição do produto"
                    :value="filters.description"
                    allow-clear
                    @change="
                        (e) =>
                            $emit('update-filter', {
                                key: 'description',
                                value: e.target.value,
                            })
                    "
                    @pressEnter="() => $emit('search')"
                />

                <a-select
                    class="cmp-ff fixed-height-select"
                    placeholder="Selecione os fornecedores"
                    mode="multiple"
                    :value="filters.provider"
                    allow-clear
                    show-search
                    option-filter-prop="label"
                    :options="
                        filter_by_providers_options.map(item => ({
                            label: item.text,
                            value: item.value,
                        }))
                    "
                    @change="
                        (value) =>
                            $emit('update-filter', {
                                key: 'provider',
                                value: value,
                            })
                    "
                />

                <a-select
                    class="cmp-ff fixed-height-select"
                    placeholder="Selecione as categorias"
                    mode="multiple"
                    :value="filters.category"
                    allow-clear
                    show-search
                    option-filter-prop="label"
                    :options="
                        filter_by_category_options.map(item => ({
                            label: item.text,
                            value: item.value,
                        }))
                    "
                    @change="
                        (value) =>
                            $emit('update-filter', {
                                key: 'category',
                                value: value,
                            })
                    "
                />

                <a-select
                    class="cmp-ff"
                    :disabled="!!my_store"
                    placeholder="Selecione a empresa"
                    :value="filters.loja"
                    allow-clear
                    show-search
                    option-filter-prop="label"
                    :options="
                        storesArray.map(item => ({
                            label: item.text,
                            value: item.value,
                        }))
                    "
                    @change="
                        (value) =>
                            $emit('update-filter', {
                                key: 'loja',
                                value: value,
                            })
                    "
                />

                <a-select
                    class="cmp-ff"
                    placeholder="Com e sem oferta"
                    :value="filters.offers"
                    allow-clear
                    :options="[
                        { label: 'Com oferta', value: 'with' },
                        { label: 'Sem oferta', value: 'without' },
                    ]"
                    @change="
                        (value) =>
                            $emit('update-filter', {
                                key: 'offers',
                                value: value,
                            })
                    "
                />

                <a-button @click="$emit('clear-filters')">
                    Limpar
                </a-button>

                <a-button
                    type="primary"
                    @click="$emit('search')"
                >
                    Filtrar
                </a-button>

                <div class="cmp-frow-sp"></div>

                <a-button @click="$emit('print')">
                    <span class="material-icons-outlined cmp-btn-icon">print</span>
                    Imprimir
                </a-button>

            </div>
            <div class="cmp-chips">
                <span
                    class="cmp-chip"
                    :class="{ on: filters.others_only }"
                    @click="toggleChip('others_only')"
                    >Novos Fornecedores</span
                >
                <span
                    class="cmp-chip"
                    :class="{ on: filters.has_observation }"
                    @click="toggleChip('has_observation')"
                    >Itens com Observações</span
                >
                <span
                    class="cmp-chip"
                    :class="{ on: filters.variation_price }"
                    @click="toggleChip('variation_price')"
                    >Alta variação de Preços</span
                >
                <span
                    class="cmp-chip"
                    :class="{ on: filters.selected_only }"
                    @click="toggleChip('selected_only')"
                    >Apenas comprados</span
                >
            </div>
        </div>

        <a-card :bordered="false" class="cmp-card" :style="selected.length && { marginBottom: '60px' }">
            <a-table
                class="cmp-table"
                size="small"
                :columns="columns"
                :data-source="products"
                :loading="is_loading"
                :pagination="pagination"
                :row-selection="rowSelection"
                :expandedRowKeys="expanded"
                row-key="prod_id"
                :rowClassName="rowClassName"
                :locale="{
                    emptyText:
                        'Nenhum produto encontrado para os filtros selecionados.',
                }"
                @change="handleTableChange"
                @expand="onExpandChange"
            >
                <template slot="produto" slot-scope="text, record">
                    <div class="cmp-pname">{{ record.descricaoProduto }}</div>
                    <div class="cmp-pcode" v-if="record.codEan || record.pro_codInterno">
                        <template v-if="record.codEan">EAN {{ record.codEan }}</template>
                        <template v-if="record.codEan && record.pro_codInterno"> · </template>
                        <template v-if="record.pro_codInterno">Cód. interno {{ record.pro_codInterno }}</template>
                    </div>
                </template>
                <template slot="ressuprimento" slot-scope="text, record">
                    <span v-if="replenishment(record)" class="cmp-repl">{{
                        replenishment(record)
                    }}</span>
                    <span v-else>—</span>
                </template>
                <template slot="qtdReq" slot-scope="text, record">
                    <b>{{ record.quantidadeCotacao || 0 }}</b>
                    {{ record.unidade_compra }}
                </template>
                <template slot="qtdSel" slot-scope="text, record">
                    <a-tooltip :title="qtdSelTooltip(record)">
                        <b :class="winningQty(record) ? 'ok' : 'zero'">{{
                            winningQty(record)
                        }}</b>
                        {{ record.unidade_compra }}
                        <small v-if="winningSellers(record).length">
                            ({{ winningSellers(record).length }} {{ winningSellers(record).length > 1 ? 'fornecedores' : 'fornecedor' }})</small
                        >
                    </a-tooltip>
                </template>
                <template slot="ultimaCompra" slot-scope="text, record">
                    <span v-if="record.last_purchase" class="cmp-lb">
                        <b>{{ record.last_purchase.valor | customCurrency }}</b>
                        <template v-if="record.last_purchase.data_geracao">
                            ·
                            {{ record.last_purchase.data_geracao | formatDateOnly }}
                        </template>
                    </span>
                    <span v-else>—</span>
                </template>
                <template slot="melhorPreco" slot-scope="text, record">
                    <span v-if="bestPrice(record) != null">{{
                        bestPrice(record) | customCurrency
                    }}</span>
                    <span v-else>—</span>
                </template>
                <template slot="precoSel" slot-scope="text, record">
                    <span v-if="winningSellers(record).length">{{
                        selectedPriceRange(record)
                    }}</span>
                    <span v-else class="cmp-none">—</span>
                </template>
                <template slot="delta" slot-scope="text, record">
                    <span
                        v-if="deltaVsLast(record) != null"
                        :class="deltaClass(deltaVsLast(record))"
                    >
                        {{
                            deltaVsLast(record) > 0
                                ? "▲"
                                : deltaVsLast(record) < 0
                                ? "▼"
                                : ""
                        }}
                        {{ Math.abs(deltaVsLast(record)).toFixed(1) }}%
                    </span>
                    <span v-else>—</span>
                </template>
                <template slot="vencedor" slot-scope="text, record">
                    <span v-if="winningSellers(record).length">
                        {{ winningSellers(record)[0].nomeFornecedor }}
                        <span
                            v-if="winningSellers(record).length > 1"
                            class="cmp-multi"
                            >+{{ winningSellers(record).length - 1 }}</span
                        >
                    </span>
                    <span v-else class="cmp-none">Sem vencedor</span>
                </template>
                <template slot="propostas" slot-scope="text, record">{{
                    (record.vencedores || []).length
                }}</template>
                <template slot="status" slot-scope="text, record">
                    <span
                        class="cmp-status-pill"
                        :style="statusPillStyle(record)"
                    >
                        <span
                            class="cmp-status-dot"
                            :style="{ background: statusColor(record) }"
                        ></span>
                        {{ statusLabel(record) }}
                    </span>
                </template>
                <template slot="acoes" slot-scope="text, record">
                    <ActionMenu :actions="productActions(record)" />
                </template>

                <template slot="expandedRowRender" slot-scope="record">
                    <OffersTable
                        :record="record"
                        :offers="record.vencedores"
                        :has-multiple-stores="hasMultipleStores"
                        :quotation-id="$route.params.id"
                        :store-id="my_store_or_filter"
                        @toggle-winner="$emit('toggle-winner', $event)"
                    >
                        <template slot="acoes" slot-scope="{ winner }">
                            <ActionMenu :actions="offerActions(winner, record)" />
                        </template>
                    </OffersTable>
                </template>
            </a-table>
        </a-card>

        <SelectionFooter
            :count="selected.length"
            item-label="produtos selecionados"
        >
            <template slot="actions">
                <a-button size="large" @click="selected = []">Limpar seleção</a-button>
                <a-button size="large" type="primary" @click="generateOrdersForSelected">
                    Gerar pedidos ({{ selected.length }})
                </a-button>
            </template>
        </SelectionFooter>

        <StoreQuantityModal
            v-if="storeModal.open"
            :winner="storeModal.winner"
            :product="storeModal.product"
            :quotation-id="storeModal.quotationId"
            @close="storeModal.open = false"
            @saved="onStoreModalSaved"
            @price-updated="onStoreModalPriceUpdated"
        />

        <NegotiationModal
            v-if="negotiationModal.open"
            :product="negotiationModal.product"
            :typing="negotiationModal.winner"
            :quotation_id="$route.params.id"
            @close="closeNegotiation"
        />

        <ProductWrapModal
            v-if="wrapModal.open"
            :product="wrapModal.product"
            :salesman="wrapModal.winner"
            @close="closeWrap"
        />
    </div>
</template>

<script>
import StandardInputAuto from "@/components/ui/inputs/StandardInputAuto.vue";
import QuotationService from "@/services/QuotationService";
import StoreQuantityModal from "./_store-quantity.modal.vue";
import OffersTable from "./_offers.table.vue";
import NegotiationModal from "@/modals/negotiate-offer/negotiate-offer.modal.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import SelectionFooter from "@/components/cliente/monitors/SelectionFooter.vue";
import currencyPrecision from "@/mixins/currencyPrecision";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { partial_order_mixin } from "@/mixins/partial-order.mixin";
import { replenishmentLabel } from "@/helpers/replenishment";

const STATUS_COLORS = {
    Comprado: { bg: "#f6ffed", color: "#389e0d" },
    "Não Comprado": { bg: "var(--pri-bg)", color: "var(--pri)" },
    "Sem oferta": { bg: "#fafafa", color: "#8c8c8c" },
};

export default {
    name: "ComparativoTab",
    mixins: [currencyPrecision, loaderMixin, partial_order_mixin],
    components: { StandardInputAuto, StoreQuantityModal, OffersTable, NegotiationModal, ProductWrapModal, ActionMenu, SelectionFooter },
    props: {
        products: { type: Array, default: () => [] },
        total_items: { type: Number, default: 0 },
        is_loading: { type: Boolean, default: false },
        filters: { type: Object, required: true },
        filter_by_providers_options: { type: Array, default: () => [] },
        filter_by_category_options: { type: Array, default: () => [] },
        storesArray: { type: Array, default: () => [] },
        my_store: [String, Number],
        page: { type: Number, default: 1 },
        total_pages: { type: Number, default: 1 },
    },
    data() {
        return {
            svc: new QuotationService(),
            expanded: [],
            selected: [],
            storeModal: {
                open: false,
                winner: null,
                product: null,
                quotationId: null,
            },
            negotiationModal: {
                open: false,
                winner: null,
                product: null,
            },
            wrapModal: {
                open: false,
                winner: null,
                product: null,
            },
        };
    },
    watch: {
        products: {
            immediate: true,
            handler(list) {
                this.expanded = list.filter(this.hasOffers).map((p) => p.prod_id);
            },
        },
    },
    computed: {
        my_store_or_filter() {
            return this.my_store || this.filters.loja;
        },
        hasMultipleStores() {
            return this.storesArray.length > 2;
        },
        columns() {
            return [
                {
                    title: "Produto",
                    key: "produto",
                    scopedSlots: { customRender: "produto" },
                },
                {
                    title: "Reabastecimento",
                    key: "ressuprimento",
                    width: 130,
                    scopedSlots: { customRender: "ressuprimento" },
                },
                {
                    title: "Qtd. req.",
                    key: "qtdReq",
                    align: "right",
                    scopedSlots: { customRender: "qtdReq" },
                },
                {
                    title: "Qtd. a comprar",
                    key: "qtdSel",
                    align: "right",
                    scopedSlots: { customRender: "qtdSel" },
                },
                {
                    title: "Últ. compra",
                    key: "ultimaCompra",
                    scopedSlots: { customRender: "ultimaCompra" },
                },
                {
                    title: "Melhor preço",
                    key: "melhorPreco",
                    align: "right",
                    scopedSlots: { customRender: "melhorPreco" },
                },
                {
                    title: "Preço sel.",
                    key: "precoSel",
                    align: "right",
                    scopedSlots: { customRender: "precoSel" },
                },
                {
                    title: "Δ vs. última",
                    key: "delta",
                    align: "right",
                    scopedSlots: { customRender: "delta" },
                },
                {
                    title: "Vencedor",
                    key: "vencedor",
                    scopedSlots: { customRender: "vencedor" },
                },
                {
                    title: "Prop.",
                    key: "propostas",
                    align: "right",
                    scopedSlots: { customRender: "propostas" },
                },
                {
                    title: "Status",
                    key: "status",
                    scopedSlots: { customRender: "status" },
                },
                {
                    title: "Ações",
                    key: "acoes",
                    width: 60,
                    scopedSlots: { customRender: "acoes" },
                },
            ];
        },
        pagination() {
            return {
                current: this.page,
                pageSize: 30,
                total: this.total_items,
                showSizeChanger: false,
                showTotal: (total, range) =>
                    `${range[0]}-${range[1]} de ${total} itens`,
            };
        },
        rowSelection() {
            return {
                selectedRowKeys: this.selected,
                onChange: (keys) => {
                    this.selected = keys;
                },
                getCheckboxProps: (record) => ({
                    props: { disabled: !this.hasOffers(record) },
                }),
            };
        },
    },
    methods: {
        replenishment(record) {
            return replenishmentLabel(record.replenishment_strategy);
        },
        openGiro(winner, record) {
            this.$emit("giro", {
                id: winner ? winner.pro_id : record.prod_id,
                provider_id: winner ? winner.idFornecedor : null,
                seller_id: winner ? winner.idVendedor : null,
                name: record.descricaoProduto,
                packing: record.embalagem,
                is_generic: record.flag_generico,
                main_product_id: record.pro_principal,
                internal_code: record.pro_codInterno,
                requested_quantity: winner ? winner.quantidade : null,
                has_order: !!winner && winner.qtdPedido > 0,
            }, null, !winner);
        },
        handleTableChange(pagination) {
            this.$emit("change-page", pagination.current);
        },
        onExpandChange(isExpanded, record) {
            if (!this.hasOffers(record)) return;
            const idx = this.expanded.indexOf(record.prod_id);
            if (isExpanded && idx === -1) this.expanded.push(record.prod_id);
            else if (!isExpanded && idx !== -1) this.expanded.splice(idx, 1);
        },
        hasOffers(record) {
            return (record.vencedores || []).length > 0;
        },
        rowClassName(record) {
            if (!this.hasOffers(record)) return "cmp-row-no-offer";
            return this.expanded.includes(record.prod_id) ? "cmp-row-expanded" : "";
        },
        toggleChip(key) {
            this.$emit("update-filter", { key, value: !this.filters[key] });
        },

        isWinner(winner) {
            if (winner.quantidade == 0 && winner.vencedor_quantidade == 0)
                return false;
            return winner.vencedor_quantidade > 0;
        },
        winningSellers(product) {
            const seen = new Set();
            return (product.vencedores || []).filter((v) => {
                if (!this.isWinner(v)) return false;
                if (seen.has(v.idVendedor)) return false;
                seen.add(v.idVendedor);
                return true;
            });
        },
        winningQty(product) {
            return this.winningSellers(product).reduce(
                (sum, v) => sum + (v.quantidade || 0),
                0
            );
        },
        qtdSelTooltip(product) {
            const sellers = this.winningSellers(product);

            if (!sellers.length) return "Nenhum vencedor definido para este produto.";

            if (sellers.length === 1) {
                return `${sellers[0].quantidade || 0} ${product.unidade_compra || ""} vindo de ${sellers[0].nomeFornecedor}.`.trim();
            }

            const breakdown = sellers
                .map((v) => `${v.nomeFornecedor}: ${v.quantidade || 0}`)
                .join(" · ");

            return `Quantidade total dividida entre ${sellers.length} fornecedores vencedores — ${breakdown}.`;
        },
        bestPrice(product) {
            const values = (product.vencedores || [])
                .map((v) => v.valor)
                .filter((v) => v != null);
            return values.length ? Math.min(...values) : null;
        },
        selectedPriceRange(product) {
            const values = this.winningSellers(product).map((v) => v.valor);
            const min = Math.min(...values);
            const max = Math.max(...values);
            const fmt = (v) => this.$options.filters.customCurrency(v);
            return min === max ? fmt(min) : `${fmt(min)} a ${fmt(max)}`;
        },
        deltaVsLast(product) {
            if (!product.last_purchase || !product.last_purchase.valor)
                return null;
            const best = this.bestPrice(product);
            if (best == null) return null;
            return (
                ((best - product.last_purchase.valor) /
                    product.last_purchase.valor) *
                100
            );
        },
        deltaVsWinner(product, winner) {
            if (!product.last_purchase || !product.last_purchase.valor)
                return null;
            return (
                ((winner.valor - product.last_purchase.valor) /
                    product.last_purchase.valor) *
                100
            );
        },
        deltaClass(delta) {
            if (delta > 0) return "up";
            if (delta < 0) return "down";
            return "flat";
        },
        statusLabel(product) {
            if (product.purchase_status === "ORDERED") return "Comprado";
            return this.hasOffers(product) ? "Não Comprado" : "Sem oferta";
        },
        statusColor(product) {
            return STATUS_COLORS[this.statusLabel(product)].color;
        },
        statusPillStyle(product) {
            const s = STATUS_COLORS[this.statusLabel(product)];
            return {
                background: s.bg,
                color: s.color,
                border: "1px solid " + s.color,
            };
        },
        productActions(record) {
            const winner = this.winningSellers(record)[0];
            const wrapNeedsWinner = !winner && !!(record.flag_generico || record.pro_principal);

            return [
                { label: "Análise de giro", icon: "query_stats", iconClass: "action-info", onClick: () => this.openGiro(winner, record) },
                {
                    label: "Alterar embalagem",
                    icon: "inventory_2",
                    iconClass: "action-warning",
                    disabled: wrapNeedsWinner,
                    tooltip: wrapNeedsWinner ? "A embalagem deste produto é a da oferta do fornecedor. Escolha um vencedor para alterar." : null,
                    onClick: () => this.openWrap(winner, record),
                },
            ];
        },
        offerActions(winner, record) {
            return [
                {
                    label: "Negociar preço",
                    icon: "handshake",
                    iconClass: "action-success",
                    disabled: winner.qtdPedido > 0,
                    tooltip: winner.qtdPedido > 0 ? "Pedido já gerado com este fornecedor — preço travado" : null,
                    onClick: () => this.openNegotiation(winner, record),
                },
                {
                    label: "Distribuir por loja",
                    icon: "storefront",
                    iconClass: "action-primary",
                    visible: this.hasMultipleStores,
                    onClick: () => this.openStoreModal(winner, record),
                },
            ];
        },
        openNegotiation(winner, record) {
            this.negotiationModal = {
                open: true,
                winner,
                product: {
                    produtoDescricao: record.descricaoProduto,
                    pro_observacao: winner.pro_observacao,
                    observacao: winner.observacao,
                    ultimaCompra: record.last_purchase
                        ? record.last_purchase.valor
                        : null,
                },
            };
        },
        closeNegotiation() {
            this.negotiationModal.open = false;
        },
        openWrap(winner, record) {
            this.$set(record, "idProduto", winner ? winner.pro_id : record.prod_id);
            this.wrapModal = { open: true, winner, product: record };
        },
        closeWrap() {
            this.wrapModal.open = false;
        },
        openStoreModal(winner, product) {
            this.storeModal = {
                open: true,
                winner,
                product,
                quotationId: this.$route.params.id,
            };
        },
        onStoreModalSaved() {
            this.storeModal.open = false;
            this.$emit("search");
            this.$emit("pre-orders-changed");
        },

        onStoreModalPriceUpdated() {
            this.$emit("search");
            this.$emit("pre-orders-changed");
        },

        generateOrdersForSelected() {
            if (!this.selected.length) return;
            if (!this.my_store_or_filter) {
                this.snack(
                    "Selecione uma empresa/loja no filtro para gerar pedidos.",
                    "error"
                );
                return;
            }
            const sellerIds = new Set();
            this.products
                .filter((p) => this.selected.includes(p.prod_id))
                .forEach((p) =>
                    this.winningSellers(p).forEach((w) =>
                        sellerIds.add(w.idVendedor)
                    )
                );
            if (!sellerIds.size) {
                this.snack(
                    "Nenhuma oferta vencedora entre os produtos selecionados.",
                    "error"
                );
                return;
            }
            if (this.partialOrdersEnabled()) {
                // Pedido parcial (CLUB-1443): mesmo recorte do legado (loja do
                // filtro + vendedores vencedores), só o que ainda não foi pedido.
                return this.partial_order_round(
                    this.$route.params.id,
                    { store_id: Number(this.my_store_or_filter), seller_ids: Array.from(sellerIds).map(Number) },
                    {
                        title: `Gerar pedido(s) para ${sellerIds.size} vendedor(es)?`,
                        text: "Os produtos vencedores ainda não pedidos desses vendedores nesta empresa serão pedidos em pedidos novos.",
                        confirmButtonText: "Gerar pedidos",
                    }
                ).then((data) => {
                    if (data) {
                        this.selected = [];
                        this.$emit("partial-order-done", data);
                    }
                    this.$emit("search");
                    this.$emit("pre-orders-changed");
                });
            }
            this.confirm_action({
                message: `Gerar ${sellerIds.size} pedido(s) para os produtos selecionados?`,
                confirm_text: "Gerar pedidos",
                callback: () => {
                    Promise.all(
                        Array.from(sellerIds).map((idvendedor) =>
                            this.svc.order({
                                idcotacao: this.$route.params.id,
                                loja: this.my_store_or_filter,
                                idvendedor,
                            })
                        )
                    )
                        .then(() => {
                            this.snack("Pedidos gerados com sucesso.");
                            this.selected = [];
                            this.$emit("search");
                            this.$emit("pre-orders-changed");
                        })
                        .catch(() => {
                            this.snack(
                                "Não foi possível gerar um ou mais pedidos.",
                                "error"
                            );
                        });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.cmp-tab {
    --pri: var(--primary-color);
    --pri-bg: var(--primary-color-opacity, rgba(232, 96, 44, 0.08));
}

.cmp-filterbar {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
}
.cmp-frow {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    flex-wrap: wrap;
}
.cmp-ff {
    flex: 1 1 160px;
    min-width: 140px;
}
::v-deep(.fixed-height-select.ant-select),
::v-deep(.fixed-height-select .ant-select-selection--multiple) {
    min-height: 32px !important;
    max-height: 32px !important;
    overflow: auto;
}
.cmp-ff-search {
    max-width: 260px;
}
.cmp-frow-sp {
    flex: 1;
}
.cmp-btn-icon {
    font-size: 16px;
    vertical-align: -3px;
    margin-right: 4px;
}
.cmp-fbtn {
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #434343;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        border-color: var(--pri);
        color: var(--pri);
    }
    &.on {
        background: var(--pri-bg);
        color: var(--pri);
        border-color: var(--pri);
    }
    &.cmp-fbtn-primary {
        background: var(--pri);
        border-color: var(--pri);
        color: #fff;
        font-weight: 600;
    }
    &.cmp-fbtn-clear {
        color: #8c8c8c;
    }
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
}
.cmp-chips {
    display: flex;
    gap: 8px;
    margin-top: 12px;
}
.cmp-chip {
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 0 12px;
    border: 1px solid #d9d9d9;
    border-radius: 999px;
    font-size: 13px;
    color: #595959;
    cursor: pointer;

    &.on {
        background: var(--pri-bg);
        border-color: var(--pri);
        color: var(--pri);
        font-weight: 600;
    }
}

.cmp-card {
    margin: 16px 20px;
    width: calc(100% - 40px);

    ::v-deep(.ant-card-body) {
        width: 100%;
        padding: 0;
    }
    ::v-deep(.ant-table-wrapper),
    ::v-deep(.ant-table),
    ::v-deep(.ant-table-content),
    ::v-deep(table) {
        width: 100%;
    }
    ::v-deep(tr.cmp-row-expanded) > td {
        background: #f0f5ff;
    }
    ::v-deep(tr.cmp-row-expanded:hover) > td {
        background: #f0f5ff;
    }
    ::v-deep(tr.ant-table-expanded-row) > td {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    ::v-deep(tr.cmp-row-no-offer) .ant-table-row-expand-icon {
        opacity: 0.4;
        cursor: not-allowed;
    }
}
.cmp-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 999px;
    white-space: nowrap;
}
.cmp-status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
}

.cmp-pname {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
}
.cmp-pcode {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 2px;
}
.cmp-repl {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    background: #f0f0f0;
    color: #595959;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.cmp-lb {
    font-size: 13px;
    color: #595959;
}
.cmp-none {
    color: #bfbfbf;
}
.cmp-multi {
    font-size: 11px;
    font-weight: 600;
    color: var(--pri);
    background: var(--pri-bg);
    border: 1px solid var(--pri);
    border-radius: 999px;
    padding: 1px 8px;
    margin-left: 6px;
}
.up {
    color: #cf1322;
}
.down {
    color: #389e0d;
}
.flat {
    color: #8c8c8c;
}
</style>
